import { api } from "@/utils/client";
import { keyBy } from 'lodash-es';
import Vue from "vue";

export default {
    namespaced: true,
    state: {
        ids: [],
        categories: [],
        list: {},
        meta: {},
        selected: undefined,
        showingDeleted: false
    },
    getters: {
        orderedList(state) {
            return state.ids.map(id => state.list[id]);
        },
        selected(state) {
            return state.list[state.selected];
        }
    },
    mutations: {
        setList(state, list) {
            state.ids = list.map(({id}) => id)
            state.list = keyBy(list, 'id');
        },
        addItem(state, {id, ...item}) {
            state.ids = [id, ...state.ids];
            Vue.set(state.list, id, {id, ...item})
        },
        updateItem(state, {id, ...item}) {
            Vue.set(state.list, id, {id, ...item})
        },
        removeItem(state, id) {
            state.ids = state.ids.filter((_id) => _id !== id);
            Vue.delete(state.list, id)
        },
        setMeta(state, meta) {
            state.meta = meta;
        },
        setCategories(state, categories) {
            state.categories = categories;
        },
        setSelected(state, selected) {
            state.selected = selected;
        },
        setShowingDeleted(state, showingDeleted) {
            state.showingDeleted = showingDeleted;
        },
    },
    actions: {
        async getList({commit, state}, params = {}) {
            const {data: {data, meta}} = await api.get('themes', {
                params: {
                    ...params,
                    deleted: state.showingDeleted ? 1 : 0
                }
            })
            commit('setList', data);
            commit('setMeta', meta);
            return data;
        },
        async getCategories({commit}) {
            const {data} = await api.get('theme-categories')
            commit('setCategories', data);
            return data;
        },
        async getById({commit}, id) {
            const {data: {data}} = await api.get(`themes/${id}`,)
            commit('addItem', data);
            return data;
        },
        async create({commit}, payload) {
            const {data: {data}} = await api.post('themes', payload)
            commit('addItem', data);
            return data;
        },
        async update({commit}, {id, ...payload}) {
            const {data: {data}} = await api.put(`themes/${id}`, payload)
            commit('updateItem', data);
            return data;
        },
        async publish({commit}, {id}) {
            const {data: {data}} = await api.put(`themes/${id}/publish`)
            commit('updateItem', data);
            return data;
        },
        async unpublish({commit}, {id}) {
            const {data: {data}} = await api.put(`themes/${id}/unpublish`)
            commit('updateItem', data);
            return data;
        },
        async delete({commit}, id) {
            await api.delete(`themes/${id}`)
            commit('removeItem', id);
        },
        async restore({commit}, id) {
            const {data: {data}} = await api.put(`themes/${id}/restore`)
            commit('updateItem', data);
            return data;
        },
        async forceDelete({commit}, id) {
            const {data: {data}} = await api.delete(`themes/${id}`, {data: {permanent: true}})
            commit('removeItem', id);
            return data;
        },
    }

}
